import { SKY_API_ENDPOINT } from './apiFetcher';
import type { ResponseError } from './apiFetcher';
import useApi from './hooks/useApi';

// Circulating USDS/DAI supply is read from sky-api (/internal/atlas/supply/).
// DAI and USDS are the only tokens whose supply comes from there; every other
// token's supply still comes from atlas.
const CIRCULATING_FIELDS = {
  DAI: 'circulating_dai',
  USDS: 'circulating_usds'
};

export function circulatingField(symbol: string): string | undefined {
  return CIRCULATING_FIELDS[symbol];
}

export function useCirculatingSupply(
  daysAgo: string | number = 1
): [any | undefined, ResponseError | undefined] {
  const [response, error] = useApi({
    baseUrl: SKY_API_ENDPOINT,
    url: '/supply/',
    queryParams: {
      days_ago: daysAgo
    }
  });
  return [response?.data, error];
}

export function useCirculatingSupplyHistoric(
  daysAgo: string | number
): [any[] | undefined, ResponseError | undefined] {
  const [response, error] = useApi({
    baseUrl: SKY_API_ENDPOINT,
    url: '/supply/historic/',
    queryParams: {
      days_ago: daysAgo
    }
  });
  return [response?.data, error];
}

// The token's circulating supply and the market cap it gives at the atlas
// price, with their changes, under the atlas token payload's field names.
export function tokenSupplyFields(
  supply: any,
  field: string,
  price: number | string,
  previousPrice?: number | string | null
) {
  const current = Number(supply[field]);
  const change = Number(supply[`${field}_change`]);
  const marketCap = current * Number(price);
  const previousMarketCap = (current - change) * Number(previousPrice ?? price);
  const marketCapChange = marketCap - previousMarketCap;

  return {
    total_corrected: current,
    total_corrected_change: change,
    total_corrected_change_percentage: supply[`${field}_change_percentage`],
    market_cap_corrected: marketCap,
    market_cap_corrected_change: marketCapChange,
    market_cap_corrected_change_percentage:
      marketCapChange / (previousMarketCap || marketCap)
  };
}
